/*
 * SSL deferred video loader.
 *
 * Each <video data-defer-video data-video-src="..."> element renders
 * with no <source> child initially — the poster attribute keeps the
 * frame visually filled. This script attaches a <source> + calls .load()
 * only when:
 *
 *   1. The viewport is wide enough that video makes sense (default
 *      threshold 768px — mobile sticks with the static poster), AND
 *   2. The element is within 200px of the viewport (IntersectionObserver
 *      with rootMargin).
 *
 * Optional attributes on the <video> tag:
 *   data-video-type   — MIME type, defaults to "video/mp4"
 *   data-video-min-vw — override the desktop-only threshold (px)
 *   data-video-mobile — "1" to load on mobile too (rare; use for hero
 *                       videos that must autoplay regardless of viewport)
 *
 * Result: on mobile the video bytes never download; on desktop they
 * download only when the visitor scrolls near them.
 */
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

  function hydrate(video) {
    if (video.__sslHydrated) return;
    video.__sslHydrated = true;
    var src = video.dataset.videoSrc;
    if (!src) return;
    var type = video.dataset.videoType || 'video/mp4';
    var source = document.createElement('source');
    source.src = src;
    source.type = type;
    video.appendChild(source);
    video.load();
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function setup() {
    var videos = document.querySelectorAll('video[data-defer-video]');
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var v = entry.target;
        var minVW = parseInt(v.dataset.videoMinVw || '0', 10);
        var allowMobile = v.dataset.videoMobile === '1';
        if (!allowMobile && window.innerWidth < minVW) return;
        hydrate(v);
        observer.unobserve(v);
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (v) { observer.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
